import { ResourceModel as BryntumResourceModel } from "@bryntum/scheduler-thin";

export class CustomResourceModel extends BryntumResourceModel {
  static get fields() {
    return [
      { name: "entity" },
      { name: "image" },
      { name: "imageUrl" },
      { name: "team" },
      { name: "skillText" },
      { name: "zoneText" },
      { name: "workMode" }
    ];
  }

  public setResourceImageUrl(imageUrl: string | null | undefined) {
    const normalizedImageUrl =
      typeof imageUrl === "string" && imageUrl.trim().length > 0
        ? imageUrl
        : null;

    this.set("imageUrl", normalizedImageUrl);
    this.set("image", normalizedImageUrl ? null : false);
  }
}
